import { render, staticRenderFns } from "./Selection.vue?vue&type=template&id=605dd44e"
import script from "./Selection.vue?vue&type=script&lang=js"
export * from "./Selection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('605dd44e')) {
      api.createRecord('605dd44e', component.options)
    } else {
      api.reload('605dd44e', component.options)
    }
    module.hot.accept("./Selection.vue?vue&type=template&id=605dd44e", function () {
      api.rerender('605dd44e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/Selection.vue"
export default component.exports